diy.angular.registerFactory('diyfmsectionsdata', 
['$injector', 'diyfmconfig', 'diyfmtracking', 'diyfmselectiondata', 'diysqueezebox',
function($injector, diyfmconfig, diyfmtracking, diyfmselectiondata, diysqueezebox) {

    var sections = [], sectionModels = [];
        
    var sourceNames = diyfmconfig.getSources(), sources = [];
    
    sourceNames.forEach(function(sourceName){
        var 
            source = $injector.get('diyfmsource' + sourceName),
            sectionModel = source.getSectionModel()
        ;
        sources.push(source);
        if (sectionModels.indexOf(sectionModel) === -1) {
            sectionModels.push(sectionModel);
        }
    });
    
    // sort sections
    sectionModels.sort(function compare(a, b) {
        return a.getOrder() - b.getOrder();
    });
    
    // add sections
    sectionModels.forEach(function(sectionModel){
        var section = new sectionModel();
        section.initializeSubsections(sources);
        // it may have no subsections if it is not available for the tariff
        if (section.getSubsections().length > 0) {
            sections.push(section);
        }
    });
    
    var startSubSection = null;
    var configSubSection = diyfmconfig.getConfig()['subSection'];

    if (configSubSection) {
        sections.forEach(function(section) {
            var results = section.getSubsections().filter(function(subsection) {
                return subsection.getTypeName() == configSubSection;
            });

            if (results.length) {
                startSubSection = results[0];
            }
        });
    }

    if (!startSubSection) {
        startSubSection = sections[0].getSubsections()[0];
    }

    var setCurrentSubsection = function(subsection) {
        // we reset the search on currentSubsection and not on subsection
        // (that will became new currentSubsection), because this way we make
        // application feel faster - if user came back later to the
        // old subsection, search is already reset and items reloaded, no waiting
        if (currentSubsection) {
            currentSubsection.resetSearch();
        }
        var source = subsection.getSource();
        if (typeof source.beforeSubsectionShow === 'function') {
            source.beforeSubsectionShow(subsection);
        }
        currentSubsection = subsection;
        diyfmselectiondata.removeAllItems(['select']);
        diyfmtracking.track('subsectionChange', {subsection: currentSubsection});
    };
    
    var setCurrentSection = function(section) {
        currentSection = section;
        setCurrentSubsection(section.getSubsections()[0]);
    };

    /* set the current subsection to be the first one */
    var currentSubsection;
    setCurrentSubsection(startSubSection);

    var getCurrentSubsection = function() {
        return currentSubsection;
    };

    var getDefaultUploadSubsection = function() {
        var targetSourceName = diyfmconfig.getDefaultUploadTarget();
        var targetSource =  $injector.get('diyfmsource' + targetSourceName);
        var targetSectionModel = targetSource.getSectionModel();
        for(var i = 0; i < sections.length; i++) {
            if (sections[i] instanceof targetSectionModel) {
                return sections[i].getDefaultUploadSubsection();
            }
        }
    };

    var getCurrentSection = function() {
        return currentSubsection.getSection();
    };

    var getSections = function() {
        return sections;
    };

    var generateUniqueSubsectionName = function(newValue, subsection, defaultPrefix) {

        var copyRegex = /\s-\s([0-9]+)$/;
        var copyReplaceRegex = /([0-9]+)$/;

        /* if folder name is empty, start from the New folder initial text */
        if (!newValue || (typeof newValue === 'string' && newValue.trim() === '')) {
            return generateUniqueSubsectionName(defaultPrefix, subsection);
        }
        /* check if name already exists */
        for (var i = 0; i < sections.length; i++) {
            var subsections = sections[i].getSubsections();
            for (var j = 0; j < subsections.length; j++) {
                /* if name already exists */
                if (newValue == subsections[j].getTitle() && subsection !== subsections[j]) {
                    /* if already a numbered copy, increase the number */
                    if (copyRegex.test(newValue)) {
                        return generateUniqueSubsectionName(newValue.replace(copyReplaceRegex, function(m, n) { return parseInt(n, 10) + 1 }), subsection);
                    } else {
                        /* if not yet, just add -1 at the end */
                        return generateUniqueSubsectionName(newValue + " - 1", subsection);
                    }
                }
            }
        }

        return newValue;
    };

    var removeSubsection = function(subsection) {
        for (var i = 0; i < sections.length; i++) {
            var subsections = sections[i].getSubsections();
            for (var j = 0; j < subsections.length; j++) {
                if (subsections[j] === subsection) {
                    /* change subsection to the previous one */
                    var changeToPreviousSection = false;
                    if (subsections[j] === getCurrentSubsection()) {
                        changeToPreviousSection = true;
                    }
                    /* remove the section */
                    subsections.splice(j, 1);

                    if (changeToPreviousSection) {
                        setCurrentSubsection(subsections[Math.max(j - 1, 0)]);
                    }
                    // TODO move this to a directive
                    diysqueezebox.refresh(jQuery('.fm-folders-list'));
                    return;
                }
            }
        }
    };

    /* make these methods public */
    return {
        setCurrentSubsection: setCurrentSubsection,
        getCurrentSubsection: getCurrentSubsection,
        setCurrentSection: setCurrentSection,
        getCurrentSection: getCurrentSection,
        getSections: getSections,
        generateUniqueSubsectionName: generateUniqueSubsectionName,
        removeSubsection: removeSubsection,
        getDefaultUploadSubsection: getDefaultUploadSubsection
    };
}]);









/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/filemanager/services/diyfmsectionsdata.js
 ** module id = 936
 ** module chunks = 0
 **/